import { Cookies } from 'react-cookie';

import { AllTrapsActivityBarChartData } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const getAllTrapsActivityBartChartData = async (
  slug: string,
  period: string,
  start_date: string,
  end_date: string,
  trap_type: TrapType,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/analitycs/all-traps-chart/${slug}/${period}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      type: trap_type,
      start_date,
      end_date,
    },
  });
  return data.data as AllTrapsActivityBarChartData[];
};
